import * as React from "react"

import { NotAllowedBlock } from "@components";


export default function numSellersColumn() {
	return {
		name: 'numSellers', label: 'Num Sellers',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { textAlign: "center" } }),
			customBodyRowRender: (value ) => {
				return !!value ? value : <NotAllowedBlock />
			}
        }
	} 
}
